import { Text } from "@/components/podkit/typography/Text";
import { type FC } from "react";
import { Link } from "react-router-dom";

export const NoEnvironmentClassesError: FC<{ onClose?: () => void }> = ({ onClose }) => {
    return (
        <Text className="text-base">
            To create an environment, please first{" "}
            <Link
                to="/settings/runners"
                onClick={onClose}
                className="text-content-link"
                data-testid="runner-onboarding-link"
                data-tracking-id="setup-runner-no-environment-classes-error"
            >
                set up a runner
            </Link>
            .
        </Text>
    );
};
